import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  toggleNewbuildingBrokerOfferBookingExistsModal,
  toggleNewbuildingBrokerProfessionalAccessBlockedModal,
} from 'shared/actions/newbuildingBrokerOfferBooking';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import {
  selectBookingExistsModalOpened,
  selectProfessionalAccessBlockedModalOpened,
} from 'shared/selectors/newbuildingBrokerOfferBooking';

import { NewbuildingBrokerProfessionalAccessBlockedModalLoadable } from './NewbuildingBrokerProfessionalAccessBlockedModalLoadable';
import { NewbuildingBrokerRequestExistsModalLoadable } from './NewbuildingBrokerRequestExistsModalLoadable';

import type { IStatusModalTextSettings } from '@cian/frontend-newbuilding-broker-callback-component';

export const NewbuildingBrokerResultModalContainer = () => {
  const { config } = useApplicationContext();
  const statusModalTextSettings =
    config.get<IStatusModalTextSettings>('newbuildingBroker.statusModalTexts') ?? undefined;
  const lkUrl = config.get<string>('newbuildingBroker.lkUrl') ?? undefined;

  const bookingExistsModalOpened = useSelector(selectBookingExistsModalOpened);
  const professionalAccessBlockedModalOpened = useSelector(selectProfessionalAccessBlockedModalOpened);

  const dispatch = useDispatch();

  const handleBookingExistsModalClose = React.useCallback(() => {
    dispatch(toggleNewbuildingBrokerOfferBookingExistsModal(false));
  }, [dispatch]);

  const handleProfessionalAccessBlockedModalClose = React.useCallback(() => {
    dispatch(toggleNewbuildingBrokerProfessionalAccessBlockedModal(false));
  }, [dispatch]);

  if (bookingExistsModalOpened) {
    return (
      <NewbuildingBrokerRequestExistsModalLoadable
        lkUrl={lkUrl}
        textSettings={statusModalTextSettings?.requestExists}
        onClose={handleBookingExistsModalClose}
      />
    );
  }

  if (professionalAccessBlockedModalOpened) {
    return (
      <NewbuildingBrokerProfessionalAccessBlockedModalLoadable onClose={handleProfessionalAccessBlockedModalClose} />
    );
  }

  return null;
};
